import type { FigmaIconProps } from './types';

export const IconFigmaStructure = ({ size = 20, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.99984 3.50016H11.0002V3.1665H8.99984V3.50016ZM12.5 4.16667C12.5 4.6269 12.1269 5 11.6667 5H8.33333C7.8731 5 7.5 4.6269 7.5 4.16667V2.5C7.5 2.03976 7.8731 1.66667 8.33333 1.66667H11.6667C12.1269 1.66667 12.5 2.03976 12.5 2.5V4.16667Z"
      fill={color}
    />
    <path
      d="M3.1665 16.8335H5.16683V16.4998H3.1665V16.8335ZM6.66667 17.5C6.66667 17.9602 6.29357 18.3333 5.83333 18.3333H2.5C2.03976 18.3333 1.66667 17.9602 1.66667 17.5V15.8333C1.66667 15.3731 2.03976 15 2.5 15H5.83333C6.29357 15 6.66667 15.3731 6.66667 15.8333V17.5Z"
      fill={color}
    />
    <path
      d="M14.8332 16.8335H16.8335V16.4998H14.8332V16.8335ZM18.3333 17.5C18.3333 17.9602 17.9602 18.3333 17.5 18.3333H14.1667C13.7064 18.3333 13.3333 17.9602 13.3333 17.5V15.8333C13.3333 15.3731 13.7064 15 14.1667 15H17.5C17.9602 15 18.3333 15.3731 18.3333 15.8333V17.5Z"
      fill={color}
    />
    <path d="M9.25 5H10.75V10H9.25V5Z" fill={color} />
    <path d="M4.16667 9.25H15.8333V10.75H4.16667V9.25Z" fill={color} />
    <path d="M3.41667 10H4.91667V15H3.41667V10Z" fill={color} />
    <path d="M15.0833 10H16.5833V15H15.0833V10Z" fill={color} />
  </svg>
);
